import React from "react";
import { connect } from "react-redux";

import { isCustomerNoticesOpen, getLastReadSchoolMoneyCustomerNoticesKey, getLastReadTeachers2ParentsCustomerNoticesKey, getAvailableProducts, getLastReadAppNoticesKey } from "state/app/selectors";
import { closeCustomerNoticeFrame, markCustomerNoticeAsRead } from "state/app/actions";
import { hasTimePassed } from "lib/validate";

import Button from "components/Button";
import ModalDialog from "components/ModalDialog";

import "./CustomerNotices.css";
import "./bar/HamburgerMenu.css";

class CustomerNotices extends React.Component {

  getTeachers2parentsNotice() {
    const {teachers2parentsNoticeKey, availableProducts} = this.props;
    if (!availableProducts.includes("teachers") || teachers2parentsNoticeKey === process.env.REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY
          || hasTimePassed(process.env.REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME)) {
      return null;
    }
    return null;
  }

  getSchoolMoneyNotice() {
    const {schoolMoneyNoticeKey, availableProducts} = this.props;
    if (!availableProducts.includes("school_money") || schoolMoneyNoticeKey === process.env.REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY
        || hasTimePassed(process.env.REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME)) {
      return null;
    }

    return null;
  }

  getAppNotice() {
    const {appNoticeKey} = this.props;

    if (appNoticeKey === process.env.REACT_APP_CUSTOMER_NOTICES_KEY || hasTimePassed(process.env.REACT_APP_CUSTOMER_NOTICES_END_TIME)) {
      return null;
    }

    return (
      <div>
        <p>The app will be undergoing maintenance on <span className="customer-notices__bold">Monday 22nd December</span> between <span className="customer-notices__bold">10:00-13:00 GMT</span>.</p>
        <p>During this period, our services will be temporarily unavailable. We apologise for any inconvenience this may cause and appreciate your understanding as we work to enhance your experience.</p>
        <p>Thank you for your patience.</p>
      </div>
    );
  }

  render() {

    if(!this.props.isOpen) {
      return null;
    }

    const appContent = null;
    const schoolMoneyContent = this.getSchoolMoneyNotice();
    const teachers2parentsContent = this.getTeachers2parentsNotice();

    if (schoolMoneyContent === null && teachers2parentsContent === null && appContent === null) {
      return null;
    }

    return (
      <ModalDialog>
        <div>
          <div className={["app-menu-button", "hamburger", "hamburger--squeeze", "is-active", "customer-notices__close-button"].join(" ")} onClick={this.props.closeCustomerNoticeFrame}>
            <span className="hamburger-box">
                <span className="hamburger-inner"></span>
            </span>
          </div>
          <h1 className="customer-notices__title">Important Message!</h1>
          <div className="customer-notices__container">
            {appContent}
            {teachers2parentsContent}
            {schoolMoneyContent}
          </div>
          <Button className="customer-notices__next-button" onClick={this.props.markCustomerNoticeAsRead}>Mark As Read</Button>
        </div>
      </ModalDialog>
    );
  }

}

export default connect(
  state => ({
    schoolMoneyNoticeKey: getLastReadSchoolMoneyCustomerNoticesKey(state),
    teachers2parentsNoticeKey: getLastReadTeachers2ParentsCustomerNoticesKey(state),
    appNoticeKey: getLastReadAppNoticesKey(state),
    isOpen: isCustomerNoticesOpen(state),
    availableProducts: getAvailableProducts(state)
  }),
  { closeCustomerNoticeFrame, markCustomerNoticeAsRead }
)(CustomerNotices);



// WEBPACK FOOTER //
// ./src/components/app/CustomerNotices.js